import React from 'react';
import styles from './HomePage.module.scss';
import Banner from '../../../components/Banner/Banner';
import Adv from '../../../components/Adv/Adv';
import Tasks from '../../../components/Tasks/Tasks';
import Works from '../../../components/Works/Works';
import Header from '../../../components/Header/Header';
import ContactUs from '../../../components/ContactUs/ContactUs';
import PriceRanges from '../../../components/PriceRanges/PriceRanges';
import Faq from '../../../components/Faq/Faq';
import ScrollTopButton from '../../../components/ScrollTopButton/ScrollTopButton';

const HomePage = () => {
  return (
    <>
      <Header />
      <div className={styles.bannerHeaderWrap}>
        <Banner />
      </div>
      <Adv />
      <Works /> <Tasks />
      {/* <PriceRanges /> */}
      <Faq />
      <ContactUs />
      <ScrollTopButton />
    </>
  );
};

export default HomePage;
